/**
 * Linha do tempo na região `timeline` do AppShell (§10.2, §4.3.3, §4.6.2, §4.7; FE §5): a `Timeline` com o
 * `completeAtTMin` lido do histórico nacional (`historySeries`, que `features/` não lê). Fica fora do App.tsx, como o
 * herói, o mapa, os painéis e os cartões, para as fases não disputarem as mesmas linhas.
 *
 * Onde aparece: em todos os modos menos a TV (a `TvTicker` ocupa o lugar, §12.3; o AppShell nem monta a seção e a
 * própria `Timeline` não renderiza na TV). A região já vem dentro da `ErrorBoundary name="timeline"` quieta (§12.8).
 * Sem ponto completo no histórico (ou antes de ele chegar), `completeAtTMin` fica ausente e a `Timeline` congela o fim
 * da trilha no 1º instante ao vivo em que viu o Brasil em 100% (M15).
 * CASCA: Fase 8b — `firstArchiveTMin` (1º item do `ArchiveIndex`) entra com o replay.
 * Na fase `after` (26/10 06h00 em diante, só com `features.site_phases`; DECISOES §86) a apuração acabou: `closed`, sem
 * o relógio de parede nem "Ao vivo" (a apuração completa está aberta a todos e não pode sugerir contagem em curso).
 */
import { useMemo } from 'preact/hooks';
import { Timeline } from '../features/timeline/Timeline';
import { completeAtFromHistory } from '../features/timeline/window';
import { historySeries } from '../state/store';
import { sitePhase } from './sitePhase';

export function TimelineSlot() {
  const points = historySeries.value;
  const completeAt = useMemo(() => completeAtFromHistory(points), [points]);
  return <Timeline completeAtTMin={completeAt ?? undefined} closed={sitePhase.value === 'after'} />;
}
